import { AppEnvironmentConfiguration } from './app-environment.config';

export const appConfig = {
	appSpecificConfig: AppEnvironmentConfiguration.getConfig().appSpecificConfig,
	appInsightsInstrumentationKey: AppEnvironmentConfiguration.getConfig().appInsightsInstrumentationKey,
	applicationName: AppEnvironmentConfiguration.getConfig().applicationName,
};

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
